import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-to-calendar',
  templateUrl: './add-to-calendar.component.html',
  styleUrls: ['./add-to-calendar.component.scss']
})
export class AddToCalendarComponent {
  @Input() googleUrl!: string | string[];

  @Input() outlookPersonalUrl!: string | string[];
  @Input() outlookWorkUrl!: string | string[];

  @Input() icsUrl!: string;
  @Input() icsFileName = 'evento.ics';

  outlookOpen = false;

  constructor(public activeModal: NgbActiveModal) {}

  private openList(urls: string | string[]) {
    const open = (url: string) => { try { window.open(url, '_blank'); } catch {} };
    Array.isArray(urls) ? urls.forEach(open) : open(urls);
  }

  openGoogle() {
    this.openList(this.googleUrl);
  }

  openOutlookPersonal() {
    this.openList(this.outlookPersonalUrl);
  }

  openOutlookWork() {
    this.openList(this.outlookWorkUrl);
  }

  downloadIcs() {
    const a = document.createElement('a');
    a.href = this.icsUrl;
    a.download = this.icsFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  toggleOutlook() {
    this.outlookOpen = !this.outlookOpen;
  }

  onOutlookKeydown(ev: KeyboardEvent) {
    if (ev.key === 'Enter' || ev.key === ' ') {
      ev.preventDefault();
      this.toggleOutlook();
    }
  }

}